const PROD = {
    VEN_CEDULA_IDENTIDAD: 23,
    VEN_CEDULA_EXTRANJERIA: 43,

    COL_UALA: 1645
};

const STAGE = {
    VEN_CEDULA_IDENTIDAD: 23,
    VEN_CEDULA_EXTRANJERIA: 58,

    COL_UALA: 1521
};

const IDS = process.env.NODE_ENV === 'production' ? PROD : STAGE;

export const PERU_BANK_CCI_IDS = [201, 203, 217, 219, 223, 228];

export default IDS;
